import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PoAutoCreatePage } from './po-auto-create.page';

const routes: Routes = [
  {
    path: '',
    component: PoAutoCreatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PoAutoCreatePageRoutingModule {}
